"use client";

// [VV9-TEARDOWN] all-paypal-express A/B test — delete this file at teardown,
// restoring the hardcoded `showPayPal` prop at every call site. See the
// checklist in @local/tracking/src/experiments/paypalVisibility.
import { c as _c } from "react/compiler-runtime";
import { type ComponentProps } from "react";
import { usePayPalVisibility } from "@local/tracking/src/experiments/usePayPalVisibility";
import { CreditCards } from "./index";
type CreditCardsPayPalProps = Omit<ComponentProps<typeof CreditCards>, "showPayPal">;

/**
 * vv9 all-paypal-express experiment wrapper for the accepted-payments logo
 * strip. Keeps the PayPal logo in step with the express-checkout button
 * (`@local/payment` express.tsx) via the shared `usePayPalVisibility` hook —
 * both read the same cookie through the same rule, so they can't disagree.
 */
export const CreditCardsPayPal = rest => {
  const $ = _c(3);
  const showPayPal = usePayPalVisibility();
  let t0;
  if ($[0] !== rest || $[1] !== showPayPal) {
    t0 = <CreditCards showPayPal={showPayPal} {...rest} />;
    $[0] = rest;
    $[1] = showPayPal;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};